import { createSlice } from '@reduxjs/toolkit';
import { jwtDecode } from "jwt-decode";


const initialState = {
  auth: localStorage.getItem("token"),
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    addAuth: (state, action) => {
      state.auth = action.payload;
    },
    deleteAuth: (state) => {
      state.auth = null;
    },
    updateAuth: (state, action) => {
      state.auth = action.payload;
    },
    logout: (state) => {
      state.auth = {
        auth: null
      }; // обнуляем локально
    },
    finishLoading: (state) => {
      state.loading = false;
    },
  },
});

export const { addAuth, deleteAuth, updateAuth, logout, finishLoading } = authSlice.actions;
export default authSlice.reducer;

export const checkToken = () => (dispatch) => {
  const token = localStorage.getItem("token");
  if (!token) {
    dispatch(finishLoading());
    return;
  }

  try {
    const decoded = jwtDecode(token);
    const now = Date.now() / 1000;

    if (decoded.exp && decoded.exp < now) {
      // токен истёк
      localStorage.removeItem("token");
      dispatch(logout());
    } else {
      // токен валиден
      console.log("токен валиден");

      dispatch(
        addAuth(JSON.parse(token))
      );
    }
  } catch (e) {
    localStorage.removeItem("token");
    dispatch(logout());
  }
};
